// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productSelectorStyles } from "@insite/content-library/Components/ProductSelector";
import { color, xScreen } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

productSelectorStyles.container = {
    gap: 12,
    offsetCss: css`
        align-items: flex-start;
    `,
};

productSelectorStyles.qtyGridItem = productSelectorStyles.unitOfMeasureGridItem = {
    css: css`
        padding-top: 26px;
        &&& {
            flex-basis: unset;
            max-width: unset;
        }
        &:empty {
            display: none;
        }

        ${xScreen("lte", "sm")} {
            padding-top: 6px;
        }
    `,
};

productSelectorStyles.clearIcon = {
    size: 16,
    css: css`
        position: absolute;
        right: 32px;
        top: 32px;
        cursor: pointer;
        &:hover {
            color: ${color("common.ui3")};
        }
    `,
};

productSelectorStyles.unitOfMeasureSelect = {
    sizeVariant: "small",
    cssOverrides: {
        formField: css`
            width: 90px;
        `,
    },
};

productSelectorStyles.searchGridItem = {
    width: [12, 12, 7, 5, 5],
    css: css`
        position: relative;
    `,
};

productSelectorStyles.searchDynamicDropdown = {
    sizeVariant: "small",
};
productSelectorStyles.buttonGridItem = {
    css: css`
        padding-top: 26px;
        &&& {
            flex-basis: unset;
            max-width: unset;
        }

        ${xScreen("lte", "md")} {
            padding-top: 6px;
        }
    `,
};
productSelectorStyles.selectButton = {
    sizeVariant: "small",
    css: css`
        min-width: 111px;
    `,
};
